import { Dropdown } from "react-bootstrap";
import CustomHGDropdown from "../../../Common/CustomHGDropdown";
import SubscriptionTermsPeriod from "../../../Common/subscription-terms-period.component";
import HighgroundDatePicker from "../../../test/TestComponent";
import PlusIcon from "../../../icons/plus.icon";
import CurrencyDropdown from "../../../Common/CurrencyDropdown";
import TaxRateDropdown /*{ deleteTaxRate, updateTaxList }*/ from "../../../Common/TaxRateDropdown";
import ReviewMoreToolsTooltip from "../../../Common/review-more-tools";
import { useEffect, useState } from "react";
import { postData } from "../../../../Utils/commonApi";
import { useAuth } from "../../../context/Auth";
import moment from "moment";
import AttackSurfaceTooltip from "../../../AttackSurface/AssetsList/AttackSurfaceTooltip";
import { getTodayFormatted } from ".";
// import useUpdateTaxRate from "../../../Common/update-tax-rate.data";

const Row = ({ title, children }) => {
  return (
    <div className="input-row d-flex align-items-center gap-12">
      <div className="input-row-title f-400 f-14 line-height-22 f-black">
        {title}
      </div>
      {children}
    </div>
  )
}

const ProductDetailsForm = ({ allModalData, multiTechnologyList = [], setAllModalData = () => { }, refreshTaxList = () => { } }) => {
  const { authTokens } = useAuth();
  const [showMTTooltip, setShowMTTooltip] = useState(false);
  // const { isLoading: isTaxRateUpdating, updateTaxRate } = useUpdateTaxRate();

  useEffect(() => {
    getExchangeRateData(allModalData?.PriceCurrencyCode_Selected?.CurrencyName, allModalData?.CostCurrencyCode_Selected?.CurrencyName)
  }, [allModalData?.CostCurrencyCode_Selected, allModalData?.PriceCurrencyCode_Selected])

  function getExchangeRateData(fromCurrency, toCurrency) {
    return new Promise((resolve, reject) => {
      postData(authTokens, "GetCurrencyConverionRate", {
        FromCurrency: fromCurrency ?? 'GBP',
        ToCurrency: toCurrency ?? 'GBP',
        accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
        Date: moment().format("YYYY-MM-DD"),
      })
        .then((response) => {
          setAllModalData((prev) => ({ ...prev, ForeignCurrencyRate: response?.Rate, ForeignCurrencyAmount: (response?.Rate * allModalData?.Price)?.toFixed(2) }));
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  } 
  
  return (
    <>
      <div className="d-flex flex-column gap-16">
        <Row title="Product Name">
          <input
            type="text"
            className="greyout-input-common f-14 line-height-22 f-black w-100"
            value={allModalData?.ProductName}
            onChange={(e) => {
              setAllModalData((prev) => ({ ...prev, ProductName: e?.target?.value }));
            }}
          />
        </Row>
        <Row title="Product SKU">
          <input
            type="text"
            className="greyout-input-common f-14 line-height-22 f-black w-100"
            value={allModalData?.ProductSKU}
            onChange={(e) => {
              setAllModalData((prev) => ({ ...prev, ProductSKU: e?.target?.value }));
            }}
          />
        </Row>
        <Row title="License Qty">
          <input
            type="text"
            className="greyout-input-common f-14 line-height-22 f-black"
            style={{ width: "100px" }}
            value={allModalData?.LicenceQuantity}
            onChange={(e) => {
              setAllModalData((prev) => ({ ...prev, LicenceQuantity: e?.target?.value }));
            }}
          />
        </Row>
        <Row title="Contract Start">
          <HighgroundDatePicker
            id="contract-end-date-asdasd"
            selected={allModalData?.ContractStartDate?.split("T")?.length > 1 ? formatDate(allModalData?.ContractStartDate)?.split(" ")[0] : allModalData?.ContractStartDate}
            onChange={(date) => {
              setAllModalData(prev => ({
                ...prev,
                ContractStartDate: convertDate(date) ?? '',
                ContractEndDate: addPeriodToDate(date, allModalData?.ContactTerm ?? 0, allModalData?.ContactTermPeriod_Selected?.DDLText ?? 'days')
              }))
            }}
          // dateFormat={dateFormat}
          />
        </Row>
        <Row title="Contract Term">
          {/* <SubscriptionTermsPeriod
            selected={allModalData?.ContactTermPeriod_Selected}
            onChange={(id, val, item) => {
              console.log(id, val, item);
            }}

          /> */}
          <input
            type="text"
            className="greyout-input-common f-14 line-height-22 f-black"
            style={{ width: "100px" }}
            value={allModalData?.ContactTerm}
            onChange={(e) => {
              setAllModalData((prev) => ({
                ...prev,
                ContactTerm: e?.target?.value,
                ContractEndDate: addPeriodToDate(allModalData.ContractStartDate, (!e?.target?.value || e?.target?.value == '') ? 0 : e?.target?.value, allModalData?.ContactTermPeriod_Selected?.DDLText ?? 'days')
              }));
            }}
          />
          <CustomHGDropdown
            fieldId={"DDLId"}
            contentwidth
            fieldValue={"DDLText"}
            selected={allModalData?.ContactTermPeriod_Selected}
            placeholder="Select"
            onClick={(id, val, item) => {
              setAllModalData(prev => ({
                ...prev,
                ContactTermPeriod_Selected: item ?? '',
                ContractEndDate: addPeriodToDate(allModalData.ContractStartDate, allModalData?.ContactTerm ?? 0, item?.DDLText ?? 'days')
              }))
            }}
            data={allModalData?.ContactTermPeriod_List}
            dropDownMenuClass="menu"
            className={"greyout-dropdown"}
            greyBackground
          />
        </Row>
        <Row title="Contract End">
          <HighgroundDatePicker
            id="contract-end-date-asdasd"
            selected={allModalData?.ContractEndDate?.split("T")?.length > 1 ? formatDate(allModalData?.ContractEndDate)?.split(" ")[0] : allModalData?.ContractEndDate}
            onChange={(date) => {
              // setAllModalData(prev => ({ ...prev, ContractEndDate: convertDate(date) ?? '' }))
            }}
            disableDatePicker
          />
        </Row>
        <Row title="Monitored By SOC">
          <CustomHGDropdown
            fieldId={"DDLId"}
            contentwidth
            fieldValue={"DDLText"}
            selected={allModalData?.MonitoredBySOC_Selected}
            placeholder="Select"
            onClick={(id, val, item) => {
              setAllModalData(prev => ({ ...prev, MonitoredBySOC_Selected: item ?? '' }))
            }}
            data={allModalData?.MonitoredBySOC_List}
            dropDownMenuClass="menu"
            className={"greyout-dropdown"}
            greyBackground
          />
        </Row>
        <Row title="Multi Technology">
          <div className="d-block">
            {
              allModalData?.MultiTechnologies_List?.map((multiTechnologyItem) => (
                <div>{multiTechnologyItem?.IntegrationTechnologyTypeName}</div>
              ))
            }
            <div className="mt-1 position-relative">
              <div className="d-flex align-items-center gap-8 f-grey pointer" onClick={() => setShowMTTooltip(true)} >
                <PlusIcon />
                <span>Add</span>
              </div>
              <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 1000 }}>
                {showMTTooltip && (
                  <ReviewMoreToolsTooltip
                    selected={allModalData?.MultiTechnologies_List}
                    techModalData={multiTechnologyList}
                    showTooltip={showMTTooltip}
                    title="Add Multi Technology"
                    onClose={() => { setShowMTTooltip(false) }}
                    onAddSuccess={(items) => {
                      setAllModalData(prev => {
                        let updatedList = items?.map(item => ({
                          ...item,
                          TechnologyEnum: item?.IntegrationTechnologyTypeEnum,
                          TechnologyName: item?.IntegrationTechnologyTypeName,
                        }));

                        return {
                          ...prev,
                          MultiTechnologies_List: updatedList,
                        };
                      });
                    }}
                    onAdd={() => { }}
                    onReviewClick={() => { }}
                    isReviewing={false}
                    setShowTooltip={setShowMTTooltip}
                  />
                )}
              </div>
            </div>
          </div>
        </Row>
        <Row title="Billing period">
          <CustomHGDropdown
            fieldId={"DDLId"}
            contentwidth
            fieldValue={"DDLText"}
            selected={allModalData?.BillingPeriod_Selected}
            placeholder="Select"
            onClick={(id, val, item) => {
              setAllModalData(prev => ({ ...prev, BillingPeriod_Selected: item ?? '' }))
            }}
            data={allModalData?.BillingPeriod_List}
            dropDownMenuClass="menu"
            className={"greyout-dropdown"}
            greyBackground
          />
        </Row>
        <Row title="Snap to unit">
          <CustomHGDropdown
            fieldId={"DDLId"}
            contentwidth
            fieldValue={"DDLText"}
            selected={allModalData?.SnapToUnit_Selected}
            placeholder="Select"
            onClick={(id, val, item) => {
              setAllModalData(prev => ({ ...prev, SnapToUnit_Selected: item ?? '' }))
            }}
            data={allModalData.SnapToUnit_List}
            dropDownMenuClass="menu"
            className={"greyout-dropdown"}
            greyBackground
          />
        </Row>
      </div>
      <div className="d-flex flex-column gap-16">
        <Row title="Cost">
          <div className="d-flex align-items-center px-2" style={{ gap: '16px' }}>
            <CurrencyDropdown
              menuClassName={
                "add-amount-currency-dropdown menu disable-transform"
              }
              width={"200px"}
              inputWidth={"144px"}
              currencyList={allModalData?.CurrencyCode_List}
              onChange={(data) => {
                setAllModalData((prev) => ({ ...prev, CostCurrencyCode_Selected: data }));
              }}
              selected={allModalData?.CostCurrencyCode_Selected}
            />
            <div
              className={`d-flex align-items-center radius-4 highlight-input  p-1  w-60`}
            >
              <div className="mr-1">
                {" "}
                {allModalData?.CostCurrencyCode_Selected?.CurrencySymbol}{" "}
              </div>
              <input
                type="number"
                className="bg-transparent border-none w-100"
                placeholder="Type"
                value={allModalData?.Cost}
                onChange={(e) => {
                  setAllModalData((prev) => ({ ...prev, Cost: e?.target?.value }));
                }}
                onFocus={(e) => {
                  if (e?.target?.value == '0' || e?.target?.value == '0.00') {
                    setAllModalData((prev) => ({ ...prev, Cost: '' }));
                  }
                }}
                onBlur={(e) => {
                  setAllModalData((prev) => ({ ...prev, Cost: currencyFormatter(e?.target?.value) }));
                }}
              />
            </div>
          </div>
        </Row>
        <Row title="Price">
          <div>
            <div className="d-flex align-items-center px-2" style={{ gap: '16px' }}>
              <CurrencyDropdown
                menuClassName={"add-amount-currency-dropdown menu disable-transform"}
                width={"200px"}
                inputWidth={"144px"}
                currencyList={allModalData?.CurrencyCode_List}
                onChange={(data) => {
                  setAllModalData((prev) => ({ ...prev, PriceCurrencyCode_Selected: data }));
                }}
                selected={allModalData?.PriceCurrencyCode_Selected}
              />
              <div
                className={`d-flex align-items-center radius-4 highlight-input  p-1  w-60`}
              >
                <div className="mr-1">
                  {" "}
                  {allModalData?.PriceCurrencyCode_Selected?.CurrencySymbol}{" "}
                </div>
                <input
                  type="number"
                  className="bg-transparent border-none w-100"
                  placeholder="Type"
                  value={allModalData?.Price}
                  onChange={(e) => {
                    setAllModalData((prev) => ({ ...prev, Price: e?.target?.value }));
                  }}
                  onFocus={(e) => {
                    if (e?.target?.value == '0' || e?.target?.value == '0.00') {
                      setAllModalData((prev) => ({ ...prev, Price: '' }));
                    }
                  }}
                  onBlur={(e) => {
                    setAllModalData((prev) => ({ ...prev, Price: currencyFormatter(e?.target?.value) }));
                    setAllModalData((prev) => ({ ...prev, Total: currencyFormatter(Number(Number(e?.target?.value) + Number((Number(e?.target?.value ?? 0) * Number(allModalData?.TaxRates_Selected?.TaxRate ?? 0)) / 100))) }));

                  }}
                />
              </div>
            </div>
            {
              allModalData?.CostCurrencyCode_Selected?.CurrencyName != allModalData?.PriceCurrencyCode_Selected?.CurrencyName && <div className="d-flex align-content-center">
                <div className="f-grey f-12 mr-1 mt-1" style={{ marginLeft: '75px' }}>
                  {`${allModalData?.CostCurrencyCode_Selected?.CurrencySymbol} ${Number(allModalData?.Price * allModalData?.ForeignCurrencyRate)?.toFixed(2)}`}
                </div>
                <AttackSurfaceTooltip
                  bottomLeft={true}
                  topLeft={false}
                  content={
                    <span>
                      <img
                        alt=""
                        width={10}
                        height={10}
                        src="/images/msp/white-exchange-rate-icon.svg"
                        className="mr-1"
                      />{" "}
                      The exchange rate on{" "}
                      {moment()?.format("DD MMM YYYY")}{" "}
                      is 1 {allModalData?.PriceCurrencyCode_Selected?.CurrencyName ?? "GBP"} ={" "}
                      {allModalData?.ForeignCurrencyRate}{" "}
                      {allModalData?.CostCurrencyCode_Selected?.CurrencyName ?? "GBP"}{" "}
                    </span>
                  }
                >
                  <img
                    alt=""
                    width={15}
                    height={15}
                    src="/images/msp/exchange-rate-icon.svg"
                    className="mr-1"
                  />
                </AttackSurfaceTooltip>
              </div>
            }
          </div>
        </Row>
        <Row title="Tax Rate">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <div
                className="flex-1 radius-4 p-2"
                style={{
                  marginTop: '2px'
                }}
              >
                <TaxRateDropdown
                  onChange={(data) => {
                    setAllModalData((prev) => ({ ...prev, TaxRates_Selected: data }));
                    setAllModalData((prev) => ({ ...prev, Total: currencyFormatter(Number(Number(allModalData?.Price) + Number((Number(allModalData?.Price ?? 0) * Number(data?.TaxRate ?? 0)) / 100))) }));

                  }}
                  taxList={allModalData?.TaxRates}
                  selected={allModalData.TaxRates_Selected}
                  updateTaxList={(data) => {
                    refreshTaxList({ taxId: data?.created });
                  }}
                />
              </div>
            </div>
            {allModalData?.TaxRates_Selected && allModalData?.TaxRates_Selected?.TaxRate ? (
              <div className="d-flex align-items-center radius-4 f-grey  p-2  mr-1">
                {allModalData?.TaxRates_Selected?.TaxRate ?? 0} % ={" "}
                {allModalData?.PriceCurrencyCode_Selected?.CurrencySymbol}{" "}
                {(Number(((allModalData?.Price ?? 0) * (allModalData?.TaxRates_Selected?.TaxRate ?? 0)) / 100 ?? 0))?.toFixed(2)}
              </div>
            ) : <></>}
          </div>
        </Row>
        <Row title="Total">
          <div className="">
            {currencyFormatterToShow(allModalData.Total, allModalData?.PriceCurrencyCode_Selected?.CurrencySymbol)}
          </div>
          {
            allModalData?.CostCurrencyCode_Selected?.CurrencyName != allModalData?.PriceCurrencyCode_Selected?.CurrencyName && <div className="d-flex align-content-center">
              <div className="f-grey f-12 mr-1 mt-1" style={{ marginLeft: '75px' }}>
                {`${allModalData?.CostCurrencyCode_Selected?.CurrencySymbol} ${Number(allModalData?.Total * allModalData?.ForeignCurrencyRate)?.toFixed(2)}`}
              </div>
              <AttackSurfaceTooltip
                bottomLeft={true}
                topLeft={false}
                content={
                  <span>
                    <img
                      alt=""
                      width={10}
                      height={10}
                      src="/images/msp/white-exchange-rate-icon.svg"
                      className="mr-1"
                    />{" "}
                    The exchange rate on{" "}
                    {moment()?.format("DD MMM YYYY")}{" "}
                    is 1 {allModalData?.PriceCurrencyCode_Selected?.CurrencyName ?? "GBP"} ={" "}
                    {allModalData?.ForeignCurrencyRate}{" "}
                    {allModalData?.CostCurrencyCode_Selected?.CurrencyName ?? "GBP"}{" "}
                  </span>
                }
              >
                <img
                  alt=""
                  width={15}
                  height={15}
                  src="/images/msp/exchange-rate-icon.svg"
                  className="mr-1"
                />
              </AttackSurfaceTooltip>
            </div>
          }
        </Row>
      </div>
    </>
  )
}

export default ProductDetailsForm;

function formatDate(input) {
  const date = new Date(input);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

function convertDate(inputDate) {
  const [day, month, year] = inputDate.split("/");
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T00:00:00`;
}

export function addPeriodToDate(dateStr = getTodayFormatted(), periodTerm = 0, period = 'days') {
  console.log('dateStr', dateStr);
  console.log('periodTerm', periodTerm);
  console.log('period', period);

  let date;

  if (dateStr.includes('/')) {
    // Format: DD/MM/YYYY
    const [day, month, year] = dateStr.split('/').map(Number);
    date = new Date(year, month - 1, day);
  } else if (dateStr.includes('T')) {
    // Format: YYYY-MM-DDTHH:mm:ss
    date = new Date(dateStr);
  } else {
    throw new Error('Unsupported date format. Use "DD/MM/YYYY" or "YYYY-MM-DDTHH:mm:ss".');
  }

  const amount = parseInt(periodTerm, 10);
  const unit = period?.trim()?.toLowerCase()?.replace(/s$/, ''); // singularize

  if (isNaN(amount) || !['day', 'month', 'year'].includes(unit)) {
    throw new Error('Invalid period. Use unit like "days", "months", or "years".');
  }

  const resultDate = new Date(date);

  switch (unit) {
    case 'day':
      resultDate.setDate(resultDate.getDate() + amount);
      break;
    case 'month':
      resultDate.setMonth(resultDate.getMonth() + amount);
      break;
    case 'year':
      resultDate.setFullYear(resultDate.getFullYear() + amount);
      break;
  }

  const yyyy = resultDate.getFullYear();
  const mm = String(resultDate.getMonth() + 1).padStart(2, '0');
  const dd = String(resultDate.getDate()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}T00:00:00`;
}

function currencyFormatter(startValue = 0) {
  if (startValue == '') {
    return "0.00";
  }
  if (isNaN(startValue)) {
    return "0.00";
  }

  let value = String(startValue);

  if (value.startsWith(".")) {
    value = "0" + value;
  }

  if (value.includes(".")) {
    const num = parseFloat(value);
    return num.toFixed(2);
  }

  return value + ".00";
}

function currencyFormatterToShow(startValue = 0, currency = "€") {
  if (startValue === "" || isNaN(startValue)) {
    return <div className="f-600 f-14">{currency} 0,00</div>;
  }

  let value = String(startValue);

  if (value.startsWith(".")) {
    value = "0" + value;
  }

  let num = parseFloat(value);
  if (isNaN(num)) num = 0;

  // Format with 2 decimals, replace dot with comma
  const formatted = num.toFixed(2).replace(".", ",");

  return <div className="f-600 f-14">{currency} {formatted}</div>;
}